import React, {Component} from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {BeatLoader} from "react-spinners";
import {connect}  from  "react-redux";
import {Redirect} from "react-router";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
class BinManagerReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            txnLists:[{value:'Leg1 QR Transaction', label: 'Leg1'},{value:'Leg2 QR Transaction', label: 'Leg2'}],
            txnValue:'',
            txnIds:'',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            isChange: false,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
            binList:[],
            bin_no:'',
            binValue:null,
            binStatusList:[],
            bin_status:'',
            binStatusValue:null,
            ciTenderModeList:[],
            ci_tender_mode:'',
            ciTenderModeValue:null,

        }
        this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidUpdate() {
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        this._getBinNo();
        this._getBin_status();
        this._getci_tender_mode();

       
       
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
//             this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
//             this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code, false,'');
            this.get_filtered_bin_manager_report(decoded.object_type,arrayCode,'');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: decoded.object_code,
                search_type:'innoviti',
                search_object_code: decoded.object_code,
            })
        }
        else if(decoded.object_type=='Merchant') {
//             this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
//             this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            setTimeout(function(){
                this.get_filtered_bin_manager_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'merchant',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Chain') {
            //this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            setTimeout(function(){
                this.get_filtered_bin_manager_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'chain',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);
            setTimeout(function(){
                this.get_filtered_bin_manager_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'store'
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }

        else {
            this.unauthorize_access();
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'bin_manager_report','sparcs')
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("support_module")===false || reportPermissions.includes("binmanager_report")===false){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    get_filtered_bin_manager_report(object_type, object_code, event) {

        var that = this;
        disabledBody();
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var postData = {
            bin_no: this.state.bin_no,
            bin_status:this.state.bin_status,
            ci_tender_mode:this.state.ci_tender_mode,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
        };
        if ($.fn.DataTable.isDataTable('#binManagerTable')) {
            $('#binManagerTable').DataTable().clear().destroy();
        }
        var binManagerTable = $('#binManagerTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/schedulereport/bin-manager-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody()
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody();
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"merchant_name", "width":"150px"},
                    {"data":"chain_name", "width":"100px"},
                    {"data":"store_name", "width":"100px"},
                    {"data":"bin_no"},
                    {"data":"bin_status"},
                    {"data":"error_bin_type"},
                    {"data":"prim_id"},
                    {"data":"transaction_status"},
                    {"data":"ci_inno_responsecode"},
                    {"data":"bi_bank_responsecode"},
                    {"data": "bo_bank_responsecode"},
                    {"data":"co_inno_responsecode"},
                    {"data":"transaction_type"},
                    {"data":"acq_bank_code"},
                    {"data":"ci_serialnumber"},
                    {"data": "ci_utid"},
                    {"data": "ci_softwareversion"},
                    {"data":"ci_customer_mobile_number"},
                    {"data":"ci_payment_mode"},
                    {"data":"ci_inno_processingcode"},
                    {"data":"ci_card_holder_name"},
                    {"data":"ci_tender_mode"},
                    {"data":"ci_mask_card_number"},
                    {"data":"co_reason_code"},
                    {"data":"co_reason_message"},
                    {"data":"card_type"},
                    {"data":"addtnlinfo1"},
                    {"data": "addtnlinfo2"},
                    {"data":"txn_timestamp"},
                    {"data":"parent_stan_no"},
                    {"data":"ufe_message"},
                    {"data":"fk_instance_id"},
                    {"data":"transaction_date"},
                    {"data":"insert_at"},
                    {"data":"valid_flag"},

                ],
                "columnDefs": [
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2,21,27]
                    },

                    {  render: function (data) {

                        if(data===null || data==='null' || data==='') {
                            return data;
                        } else {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';

                        }
                        },
                        "targets": [25,29,30],
                    },
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [16],
                        "width": "250px"
                    },

                ],

            });
    }

    _getBinNo(){
        axios.get(config.get('API_URL')+'/filters/bin_no_filter/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((bin, index) => {
                    mList.push({value: bin.bin_no, label: bin.bin_no})
                });
                this.setState({
                    binList:mList,

                })
            }
        });
    }

    _getBin_status(){
        axios.get(config.get('API_URL')+'/filters/bin_status_filter/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((bin, index) => {
                    mList.push({value: bin.bin_status, label: bin.bin_status})
                });
                this.setState({
                    binStatusList:mList,

                })
            }
        });
    }
    _getci_tender_mode(){
        axios.get(config.get('API_URL')+'/filters/ci_tender_mode_filter/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((bin, index) => {
                    mList.push({value: bin.ci_tender_mode, label: bin.ci_tender_mode})
                });
                this.setState({
                    ciTenderModeList:mList,

                })
            }
        });
    }

    changeBinNo(optionSelected){
        let value='';
        let binArray = [];
        if(optionSelected.length<1){
            value = null;
            binArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                binArray.push(mids.value)

            });
        }

        this.setState({
            bin_no:binArray,
            binValue:optionSelected,
            isChange: true,

        });


    }
    changeBinStatus(optionSelected){
        let value='';
        let binsArray = [];
        if(optionSelected.length<1){
            value = null;
            binsArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                binsArray.push(mids.value)

            });
        }

        this.setState({
            bin_status:binsArray,
            binStatusValue:optionSelected,
            isChange: true,

        });


    }
    changeCiTenderMode(optionSelected){
        let value='';
        let ciTenderArray = [];
        if(optionSelected.length<1){
            value = null;
            ciTenderArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                ciTenderArray.push(mids.value)

            });
        }

        this.setState({
            ci_tender_mode:ciTenderArray,
            ciTenderModeValue:optionSelected,
            isChange: true,

        });


    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)

                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value == cids.value);
                    this.state.chainList.move(index, 0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            isChange: is_enable,
            search_code: cidArray,
            search_type:'chain',
            storeObject:[],
            search_object_code: this.state.merchantID,
        });
        //this.get_filtered_bin_manager_report(this.state.merchantID, cidArray, '', this.state.yestSend, this.state.todSend);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
        }

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            var is_enable = compareValues(sidArray, this.state.active_sids);
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: is_enable
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,
                        isChange: true,
                        ciutidIds: '',
                        ciutidValue: [],
                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }


    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            var is_date_change = false;
            if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
                is_date_change = false;
            } else {
                is_date_change = true;
            }
            this.setState({
                isChange: is_date_change
            })
            //this.get_filtered_bin_manager_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.yestSend, this.state.todSend)
        }
    }
BinManagerDownloadCheck(){

      this.BinManagerDownload()

    }
    BinManagerDownload (e){
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if (days_beet > 30) {
            alert("Date range too large. Please select a date range of 30 days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            bin_no: this.state.bin_no,
            bin_status:this.state.bin_status,
            ci_tender_mode:this.state.ci_tender_mode,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            download: true

        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/schedulereport/bin-manager-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyAcqFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this),
            error: function(data) {
                that.closeModal();
                alert("Failed to download data. Please try again");
            }
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyAcqFile(remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'bin_manager_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    reset_all(e){

        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',

        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    DistinctBinManagerDownloadCheck(){

      this.DistinctBinManagerDownload()

    }
    DistinctBinManagerDownload (e){
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if (days_beet > 30) {
            alert("Date range too large. Please select a date range of 30 days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            bin_no: this.state.bin_no,
            bin_status:this.state.bin_status,
            ci_tender_mode:this.state.ci_tender_mode,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            download: true

        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/schedulereport/distinct_bin-manager-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyAcqFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyAcqFile(remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'bin_manager_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    reset_all(e){

        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',

        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }

    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })
        return(
           
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">BinManager Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                             onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                <input type="text" name="dateRange"
                                                       className="form-control dateRangeInput"
                                                       value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                            </DateRangePicker>
                                        </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Bin No</label>
                                                <ReactMultiSelectCheckboxes name="bin_no"
                                                    isMulti
                                                    value={this.state.binValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    options={this.state.binList}
                                                    onChange={this.changeBinNo.bind(this)}
                                                    placeholderButtonLabel="Select [Bin No]"
                                                />

                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Bin Status</label>
                                                <ReactMultiSelectCheckboxes name="bin_status"
                                                    isMulti
                                                    value={this.state.binStatusValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    options={this.state.binStatusList}
                                                    onChange={this.changeBinStatus.bind(this)}
                                                    placeholderButtonLabel="Select [Bin Status]"
                                                />

                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Tender Mode</label>
                                                <ReactMultiSelectCheckboxes name="bin_no"
                                                    isMulti
                                                    value={this.state.ciTenderModeValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    options={this.state.ciTenderModeList}
                                                    onChange={this.changeCiTenderMode.bind(this)}
                                                    placeholderButtonLabel="Select [Tender Mode]"
                                                />

                                                <div className="clearfix"></div>
                                            </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_bin_manager_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp;&nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.BinManagerDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" style={{right: "350px"}} onClick={this.DistinctBinManagerDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Distinct Bin
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="binManagerTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                <th>Merchant Name</th>
                                                <th>Chain Name</th>
                                                <th>Store Name</th>
                                                <th>Bin no</th>
                                                <th>Bin status</th>
                                                <th>Error bin type</th>
                                                <th>Prim Id</th>
                                                <th>Transaction status</th>
                                                <th>ci inno responsecode</th>
                                                <th>bi bank responsecode</th>
                                                <th>bo bank responsecode</th>
                                                <th>co inno responsecode</th>
                                                <th>transaction type</th>
                                                <th>acq bank code</th>
                                                <th>ci serialnumber</th>
                                                <th>ci utid</th>
                                                <th>ci softwareversion</th>
                                                <th>ci customer mobile number</th>
                                                <th>ci payment mode</th>
                                                <th>ci inno processingcode</th>
                                                <th>ci card holder name</th>
                                                <th>ci tender mode</th>
                                                <th>ci mask card number</th>
                                                <th>co reason code</th>
                                                <th>co reason message</th>
                                                <th>card_type</th>
                                                <th>addtnlinfo1</th>
                                                <th>addtnlinfo2</th>
                                                <th>txn timestamp</th>
                                                <th>parent stan no</th>
                                                <th>ufe message</th>
                                                <th>fk_instance_id</th>
                                                <th>Transaction date</th>
                                                <th>Insert at</th>
                                                <th>Valid flag</th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      
        );
    }
}
const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(BinManagerReport)